// extracted by mini-css-extract-plugin
module.exports = {"paper":"Drawer_paper__25TQC","onlyContentScroll":"Drawer_onlyContentScroll__2vGgv","header":"Drawer_header__3FruS","footer":"Drawer_footer__2-tgD"};